import React from 'react';
import {
  Block,
  Checkbox,
  Flex,
  Radio,
  RadioGroup,
  SelectInput,
  Spacer,
  Text,
} from 'vcc-ui';

export const Settings = ({ theme, rtl, variant }) => {
  return (
    <Flex>
      <Text variant="bates" extend={{ textAlign: 'center' }}>
        Settings
      </Text>
      <Spacer size={2} />
      <Block>
        <RadioGroup legend="Theme" {...theme.props}>
          <Radio value="light" label="Light" />
          <Radio value="dark" label="Dark" />
        </RadioGroup>
      </Block>
      <Spacer />
      <Block>
        <Checkbox label="RTL" {...rtl.props} />
      </Block>
      <Spacer size={2} />
      <Text as="label" subStyle="emphasis">
        <SelectInput label="Button Variant" {...variant.props}>
          <option value="default">Default</option>
          <option value="outline">Outline</option>
          <option value="text">Text</option>
        </SelectInput>
      </Text>
    </Flex>
  );
};
